(function() {
    'use strict';

    angular.module('sites', [
            'ui.router',
            'sites.services'
        ]
    ).config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst',];

    function uiRouting($stateProvider, userPermissionsConst, appliancesPermissionsConst) {}
})();
